<template>
  <app-autocomplete
    filter
    :items="options"
    :label="$t('vouchers.customNumber')"
    label-icon="icon-voucher-number"
    hide-details
    multiple
    dense
    solo
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import { mapState } from 'vuex';
import { NAMESPACE } from '@/modules/User/store';

export default {
  name: 'SapNumberSelect',

  computed: {
    ...mapState(NAMESPACE, { items: 'creditorVoucherSapNumbers' }),

    options() {
      return [...new Set(this.items.map(({ sapNumber }) => sapNumber))];
    }
  }
};
</script>
